import { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import Container from '@/components/Create_V2/Container';
import EmbedList from '@/components/Create_V2/EmbedList';
import Header from '@/components/Create_V2/Header';
import { useCreateStore } from '@/store/create';
import { useParams, useLocation } from 'react-router-dom';

export default () => {
  const { t } = useTranslation();
  const { creating, embedOpened, setDatasetId, setEmbeddingModelName, setPageType } = useCreateStore();
  const { datasetId } = useParams();
  const location = useLocation(); // 获取 location 对象
  const queryParams = new URLSearchParams(location.search); // 解析查询参数
  const id = queryParams.get('id'); // 获取查询参数中的 id
  const headerInfo = useMemo(() => {
    const currentDatasetId = id || datasetId;
    if (embedOpened) {
      return {
        title: t('create_v2.create_embed.title'),
        desc: t('create_v2.create_embed.desc'),
      };
    }

    const info = {
      title: currentDatasetId ? t('create_v2.add_new_source') : t('create_v2.title'),
      desc: currentDatasetId ? t('create_v2.add_data_to_your_chat') : t('create_v2.desc'),
    };

    if (creating) {
      info.desc = t('create_v2.learning_data');
    }

    return info;
  }, [id, datasetId, t, embedOpened, creating]);

  useEffect(() => {
    const currentDatasetId = id || datasetId; // 使用 id 或 datasetId

    if (currentDatasetId) {
      setPageType('modify');
      setDatasetId(currentDatasetId);
    }

    return () => {
      // clear
      setPageType('create');
      setDatasetId('');
    };
  }, [id, datasetId, setDatasetId]);

  useEffect(() => {
    setEmbeddingModelName('text-embedding-3-large');
  }, []);

  return (
    <>
      <Header title={headerInfo.title} description={headerInfo.desc} />
      <section>{embedOpened ? <EmbedList /> : <Container />}</section>
    </>
  );
};
